import SrAdd from "./SrAdd.vue";

SrAdd.install = function(Vue) {
  Vue.component(SrAdd.name, SrAdd);
};

export default SrAdd;



// WEBPACK FOOTER //
// ./packages/SrAdd/index.js